/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProductSummary } from './productSummary';

export interface GenericProductCategory {
  categoryId?: number;
  externalId?: number;
  parentId?: number;
  productIds?: Array<number>;
  productsList?: Array<ProductSummary>;
  subcategoriesList?: Array<GenericProductCategory>;
}
